import {TOOLTIP_POSITION} from '@Components/tooltip';
import {getClassesForPosition} from '@Components/tooltip/tooltip-helper';
import {TooltipPlacement} from './icon-with-tooltip.types';

const ARROW_POSITIONS_OF_TOOLTIPS_BELOW_TRIGGER: TOOLTIP_POSITION[] = [TOOLTIP_POSITION.TOP_MIDDLE, TOOLTIP_POSITION.TOP_LEFT, TOOLTIP_POSITION.TOP_RIGHT];

export function getTooltipOverlayClassName(hideArrow: boolean, arrowPosition: TOOLTIP_POSITION): string {
  return [getGapClassForArrowPosition(arrowPosition), hideArrow ? null : '_rounded-arrow', getClassesForPosition(arrowPosition)].filter(Boolean).join(' ');
}

function getGapClassForArrowPosition(arrowPosition: TOOLTIP_POSITION): string {
  return ARROW_POSITIONS_OF_TOOLTIPS_BELOW_TRIGGER.includes(arrowPosition) ? 'spacing-m-t-1' : 'spacing-m-b-1';
}

export function deriveArrowPositionFromPlacement(placement: TooltipPlacement): TOOLTIP_POSITION {
  switch (placement) {
    case TooltipPlacement.BOTTOM:
      return TOOLTIP_POSITION.TOP_MIDDLE;
    case TooltipPlacement.LEFT:
      return TOOLTIP_POSITION.BOTTOM_RIGHT;
    case TooltipPlacement.RIGHT:
      return TOOLTIP_POSITION.BOTTOM_LEFT;
    case TooltipPlacement.TOP:
    default:
      return TOOLTIP_POSITION.BOTTOM_MIDDLE;
  }
}
